import React, { FC } from 'react'
import CarePlanList from './CarePlanList'
import CarePlanDetail from './CarePlanDetail'
import { CarePlanBundle } from '../../../../types/FHIRTypes/Bundle'
import { CarePlanDisplayType } from '../../../../types/CarePlanDisplayType'

type CarePlansProps = {
  clientCarePlanType: CarePlanDisplayType;
  carePlanData: CarePlanBundle;
  carePlanDetailId: string | undefined;
  page: string | undefined;
  isFetching: boolean;
  handleChangePage: (page: number) => void
  totalPages: number;
  currentPage: number;
}

const CarePlans: FC<CarePlansProps> = ({ clientCarePlanType, carePlanData, carePlanDetailId, page, isFetching, handleChangePage, totalPages, currentPage }) => {
  return (
    <div>
      {
        carePlanDetailId && page === 'CarePlan'
          ? (
            <CarePlanDetail
              carePlanDetailId={carePlanDetailId}
              displayType={clientCarePlanType}
            />
          )
          : (
            <CarePlanList
              carePlanData={carePlanData}
              handleChangePage={handleChangePage}
              isFetching={isFetching}
              totalPages={totalPages}
              currentPage={currentPage}
              displayType={clientCarePlanType}
            />
          )
      }
    </div>
  )
}

export default CarePlans